export default defineNuxtPlugin(() => {
  // @see https://nuxt.com/docs/guide/recipes/custom-usefetch
  const api = $fetch.create({
    baseURL: useRuntimeConfig().public.api_host,
  });

  return {
    provide: {
      api
    }
  }
});
